<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WzkHzo/images/9781439667934.jpg?1684515194673" alt="This image is the cover for the book Spokane International Railway, Images of Rail"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spokane International Railway, Images of Rail
      </h1>
      <p class="bookDescription body article font2">
        <p>The last half of the 19th century was typified by tycoons and shrewd railroad barons. A key figure in the development of the Spokane International Railway was James Jerome Hill, or simply Jim Hill. Spokane businessmen regarded Hill as a tyrant and considered his Great Northern and Northern Pacific railroads unwelcome monopolies in Northeast Washington and the Idaho Panhandle. In 1905, Daniel Chase "D.C." Corbin broke the Hill lines' stronghold by forming the Spokane International Railway as a 140-mile rail line from Spokane, Washington, to Eastport, Idaho, to interchange traffic from the Canadian border to the Pacific. Today, the route continues to be profitable under Union Pacific Railroad ownership with commodities shipped to Western markets via the Canadian Pacific Railway. This book shares the story of the Spokane International Railway and traces its international and local connections with every major railroad in the Pacific Northwest.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dale W. Jones
      </h2>
      
      <p class="authorDescription body article">Dale W. Jones has spent 50 years chronicling railroads in the Pacific Northwest. This narrative highlights scores of images from the lens of renowned Spokane International Railway photographer Larry Shawver and provides a trip up the Burnt Cabin Creek Railroad and through the Hoodoos.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b2380b32